import React, { useState } from 'react';
import './Support.css';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { sendSupportAcknowledgementToUser, sendSupportTicketToTeam } from '../../api/supportAPI';
import { publishToHcs } from '../../api/auditAPI';

function Support() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, email, message } = formData;
    const supportId = `${uuidv4()}`;

    try {
      await sendSupportAcknowledgementToUser(name, email, supportId);
      await sendSupportTicketToTeam(name, email, message, supportId);

       const messageObj = {
                        "event": "Support Request",
                        "message": `Support request has been sent successfully`,
                        "timestamp": new Date().toISOString(),
                        "status": "success"
                      }
                          await publishToHcs(messageObj)
                          console.log('Published audit for Support Request')
              

      Swal.fire({
  icon: 'success',
  title: 'Support Request Submitted',
  html: `
    <p>Thank you <strong>${name}</strong>, your request has been received.</p>
    <p><strong>Support ID:</strong> ${supportId}</p>
    <p>Our team will get back to you shortly.</p>
  `,
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  iconColor: document.body.classList.contains('dark-mode') ? '#60a5fa' : '#048cd4',
  customClass: {
    popup: 'swal-custom'
  }
});


      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      console.error('Support Email Error:', err);

     Swal.fire({
  icon: 'error',
  title: 'Submission Failed',
  text: 'Failed to send support request. Please try again later.',
  background: document.body.classList.contains('dark-mode') ? '#1f2937' : '#fff',
  color: document.body.classList.contains('dark-mode') ? '#f9fafb' : '#111',
  iconColor: document.body.classList.contains('dark-mode') ? '#f87171' : '#d33',
  customClass: {
    popup: 'swal-custom'
  }
});

    }

    setLoading(false);
  };

  return (
    <div className="page support-page">
      <h2 className="page-title">Support</h2>
      <p className="page-description">
        Need help or have questions? Reach out to our support team and we’ll get back to you as soon as possible.
      </p>
      <div className="support-card">
        <h3>Contact Support</h3>
        <form className="support-form" onSubmit={handleSubmit}>
          <label>Name</label>
          <input type="text" name="name" placeholder="Your name" value={formData.name} onChange={handleChange} required />

          <label>Email</label>
          <input type="email" name="email" placeholder="Your email" value={formData.email} onChange={handleChange} required />

          <label>Message</label>
          <textarea name="message" placeholder="Describe your issue or question..." rows="4" value={formData.message} onChange={handleChange} required />

          <div className="support-button-wrapper">
            <button type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Support;
